










import {Component, Vue, Watch} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import CompareTable from "@/components/Compare/CompareTable.vue";
import CompareService from "@/service/CompareService";
import CompareModal from "@/components/Compare/CompareModal.vue";

@Component({
  components: {CompareModal, CompareTable}
})
export default class Compare extends Vue {
  private productIds: number[] | null = null;
  private attributeSetId: number | null = null;
  private attributeSet: AttributeSet | null = null;
  private mobileBreakPoint = 768;
  private isMobile = true;

  async mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.checkIsMobile);
    this.getProductIdsFromUrl();
    this.getAttributeSetIdFromUrl();
    this.onAttributeSetChange();
    this.checkIsMobile();
    await this.getAttributeSetFromServer();
  }

  getProductIdsFromUrl() {
    if (this.$route.query.products) {
      const productIdsQueryParam = this.$route.query.products.toString();
      this.productIds = productIdsQueryParam.split("-").map(function (num) {
        return parseInt(num);
      });
    } else {
      this.productIds = [];
    }
  }

  getAttributeSetIdFromUrl() {
    const attributeSetIdQueryParam = this.$route.query.set.toString();
    this.attributeSetId = parseInt(attributeSetIdQueryParam);
  }

  async getAttributeSetFromServer() {
    if (this.attributeSetId) {
      this.attributeSet = await CompareService.getAttributeSet(this.attributeSetId);
    }
  }

  get pageTitle(): string {
    if (this.attributeSet) {
      return "لیست مقایسه " + this.attributeSet.name;
    }
    return "لیست مقایسه";
  }

  checkIsMobile() {
    this.isMobile = window.innerWidth <= this.mobileBreakPoint;
  }

  @Watch('attributeSet')
  onAttributeSetChange() {
    document.title = this.pageTitle;
  }

  async addProductToCompare(productId: number) {
    if (this.attributeSetId) {
      const response = await CompareService.addProduct(this.attributeSetId, productId)
      if (response.success) {
        if (this.productIds) {
          this.productIds.push(parseInt(productId.toString()));
        }
      }
    }
  }

  async removeProductFromCompare(productId: number) {
    if (this.attributeSetId) {
      const response = await CompareService.removeProduct(this.attributeSetId, productId)
      if (response.success) {
        if (this.productIds) {
          const index = this.productIds.indexOf(parseInt(productId.toString()));
          if (index > -1) {
            this.productIds.splice(index, 1);
          }
        }
      }
    }
  }

  @Watch('productIds')
  private changePageUrl(): void {
    // const newQuery = Object.create(this.$route.query);
    const newQuery = Object.assign({}, this.$route.query);
    const productsParam = this.productIds?.join("-");
    if (productsParam != newQuery.products) {
      if (this.productIds) {
        if (this.productIds.length > 0) {
          newQuery.products = this.productIds.join("-");
        }else {
          delete newQuery.products;
        }
      } else {
        delete newQuery.products;
      }

      this.$router.replace({ query: newQuery });

      const compareChangedEvent = new Event('compare-changed');
      window.dispatchEvent(compareChangedEvent);
      //this.$router.push({path: '', query: newQuery})

      // location.reload();
    }
  }

  // @Watch('$route')
  // onRouteChanged() {
  //   const productsParam = this.productIds?.join("-");
  // }
}
